<template>
  <div class="reports-index">
    <h3 v-if="$store.state.project.plan">{{ $store.state.project.plan.name }}</h3>
    <div class="reports-ul">

      <router-link
        :to="`/dashboard/${report.route}`"
        v-for="(report, i) in reports"
        :key="i"
        v-if="$store.state.project[report.path]"
        class="reports-li"
      >
        <span>
          <img :src="report.icon" class="icon-menu"/>
          {{ report.label }}</span> <i class="fas fa-chevron-right"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import DatePicker from "vue2-datepicker";
import {apiUrl} from "../../../plugins/firebase";
import firebase from "firebase";

export default {
  name: 'Index',
  components: {DatePicker},

  data() {
    return {
      reports: [
        {
          label: 'Задачи',
          route: 'tasks',
          path: 'tasks',
          icon: require('@/assets/icon/zadach.svg'),
        },
        {
          label: 'Наряды',
          route: 'workorders-reports',
          path: 'workorder',
          icon: require('@/assets/icon/report-material.svg'),
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.reports-index {
  margin: 0 auto;
  max-width: 400px;
  padding-top: 20px;
}


.reports-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .reports-li {
    span {
      display: flex;
      align-items: center;
    }
    img {
      margin-right: 8px;
    }
  }

  .reports-li, > > > .reports-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;
    text-decoration: none;
    color: #000;

    &.active {
      background: rgba(54, 118, 203, 0.26) !important;
    }

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Tasks/Index.vue